import { useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const useGoTab = () => {
  const [, setParams] = useSearchParams();
  return (tab) => { setParams({ tab }); window.scrollTo({ top: 0, behavior: "smooth" }); };
};

export const ContinueCard = ({ title, text, actions, testId }) => (
  <div className="panel p-4 flex flex-wrap items-center gap-3 border-emerald-500/40 bg-emerald-900/10" data-testid={testId}>
    <div className="min-w-0 flex-1">
      <p className="text-[10px] uppercase tracking-[0.18em] text-emerald-300">Next stage</p>
      <p className="text-sm text-slate-100 font-medium">{title}</p>
      {text && <p className="text-xs text-slate-400 mt-0.5">{text}</p>}
    </div>
    <div className="flex flex-wrap gap-2">
      {actions.map((a) => (
        <button key={a.label} type="button" onClick={a.onClick} disabled={a.disabled} data-testid={a.testId}
          className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-emerald-700 hover:bg-emerald-600 text-white text-sm transition-colors disabled:opacity-60">{a.label}<ArrowRight size={14} /></button>
      ))}
    </div>
  </div>
);
